import {Breed} from "./breed";

export class PetType {
    id: number;
    ident: string;
    name: string;
    breeds: Breed[];

    constructor(petType: any) {
        this.id = petType.id;
        this.ident = petType.ident;
        this.name = petType.name;
        this.breeds = petType.breeds.map((breed: any) => new Breed(breed));
    }
}
